import React from 'react';

const FooterNavigation: React.FC<{
  currentStep: number;
  totalSteps: number;
  handleNext: () => void;
  handleBack: () => void;
  handleSubmit: () => void;
  handleConnect?: () => void;
  type: 'campaign' | 'accountSetup';
  connected?: boolean;
  isStepValid?: boolean;
  showReviewLaunch?: boolean; // Add this new prop
}> = ({
  currentStep,
  totalSteps,
  connected,
  handleNext,
  handleBack,
  handleSubmit,
  handleConnect,
  type,
  isStepValid = true,
  showReviewLaunch = false, // Default to false
}) => {
    return (
      <div className="flex justify-between mt-8 max-w-2xl mx-auto space-x-3">
        {/* Back Button */}
        <button
          type="button"
          className={`bg-[#00000014] font-inter text-lg font-medium text-black px-4 py-2 rounded-lg flex-1 ${currentStep === 1 ? 'cursor-not-allowed opacity-50' : ''
            }`}
          onClick={handleBack}
          disabled={currentStep === 1}
        >
          Back
        </button>

        {/* Conditional Rendering for Next, Connect, and Submit Buttons */}
        {type === 'accountSetup' && currentStep === 3 && !connected ? (
          // Connect Button for accountSetup type, step 3, and not connected
          <></>
        ) : currentStep === totalSteps && type === 'campaign' && !showReviewLaunch ? (
          // Next Button for campaign type, last step, and review not shown
          <button
            type="button"
            className={`bg-[#6277FF] font-inter text-lg font-medium text-white px-4 py-2 rounded-lg flex-1 ${!isStepValid ? 'cursor-not-allowed opacity-50' : ''
              }`}
            onClick={handleNext}
            disabled={!isStepValid}
          >
            Next
          </button>
        ) : currentStep === totalSteps ? (
          // Submit Button for the final step (either accountSetup or campaign with review shown)
          <button
            type="button"
            className={`font-inter text-lg font-medium text-white px-4 py-2 rounded-lg flex-1 
            ${!isStepValid ? 'bg-[#6277FF] opacity-50 cursor-not-allowed' : 'bg-[#6277FF]'}
          `}
            onClick={handleSubmit}
            disabled={!isStepValid}
          >
            {type === 'accountSetup' ? 'Proceed to Campaign Creation' : 'Submit'}
          </button>
        ) : (
          // Next Button for all other cases
          <button
            type="button"
            className={`bg-[#6277FF] font-inter text-lg font-medium text-white px-4 py-2 rounded-lg flex-1 ${!isStepValid ? 'cursor-not-allowed opacity-50' : ''
              }`}
            onClick={handleNext}
            disabled={!isStepValid}
          >
            Next
          </button>
        )}
      </div>
    );
  };

export default FooterNavigation;